import React from "react";
import { NavLink } from "react-router-dom";

import ParentMenu from "../Parent/parentpages/ParentMenu";

/**
 * Top navigation bar of the dashboard.
 *
 * Props:
 * - toggleSideBar: collapses / expands the side navigation.
 *
 * Styles live in ./DashBoard.css (imported by DashBoardComponent).
 */
function DashBoardNav(props: any) {
  return (
    <nav className="sb-topnav pp-topnav navbar navbar-expand navbar-dark bg-ivy-dark">
      {/* Side navigation toggle */}
      <button
        type="button"
        className="btn btn-link btn-sm"
        id="sidebarToggle"
        aria-label="Toggle navigation"
        aria-controls="layoutSidenav_nav"
        onClick={props.toggleSideBar}
      >
        <i className="fa fa-bars" aria-hidden="true"></i>
      </button>

      {/* Brand */}
      <NavLink
        className="navbar-brand nav-link pp-brand d-flex align-items-center"
        to="/home"
      >
        <img src="/favicon.ico" alt="" width={36} height={36} />
        <span className="pp-brand-label">Parent Portal</span>
      </NavLink>

      {/* Parent account menu (profile, language, logout, ...) */}
      <ParentMenu />
    </nav>
  );
}

export default DashBoardNav;
